<template>
  <!-- 0402 width 변경-->
  <w-sliding-popup type="full" ref="slidingPopup" title="자동화 수행" @close="closePopup" :default-content="false">
    <div slot="title">
      <w-datetime-range-button v-show="activeTab != 'execution'" ref="datetimeRangeButton"/>
    </div>
    <div slot="content" class="body-no-footer body-content">
        <el-tabs class="fit-card-tabs" type="card" v-model="activeTab">
          <el-tab-pane label="자동화 요약" name="summary" class="h100 w100">
            <el-scrollbar>
              <w-execution-summary :active="activeTab === 'summary'" @change-active-tab="changeActiveTab"></w-execution-summary>
            </el-scrollbar>
          </el-tab-pane>
          <el-tab-pane label="자동화 수행" name="execution" class="h100 w100">
            <el-scrollbar>
              <w-execute-trigger :active="activeTab === 'execution'"></w-execute-trigger>
            </el-scrollbar>
          </el-tab-pane>
          <el-tab-pane label="자동화 수행 결과" name="result" class="h100 w100">
            <el-scrollbar>
              <w-execution-result :active="activeTab === 'result'" :active-sub-tab="activeSubTab" :summary-filters="filters"
              @change-sub-tab="changeSubTab" @force-result-load="forceAmsTriggerResultLoad"></w-execution-result>
            </el-scrollbar>
          </el-tab-pane>
        </el-tabs>
      <w-action-progress v-if="popupVisible"/>
    </div>
  </w-sliding-popup>
</template>

<script>
import { isEmpty } from 'lodash';
import WDatetimeRangeButton from '@/components/button/DatetimeRangeButton';
import WActionProgress from '@/components/progressbar/ActionProgress';
import WExecutionSummary from './components/ExecutionSummary';
import WExecuteTrigger from './components/ExecuteTrigger';
import WExecutionResult from './components/ExecutionResult';

export default {
  name: 'WAmsSlidingPopup',
  components: {
    WDatetimeRangeButton,
    WActionProgress,
    WExecutionSummary,
    WExecuteTrigger,
    WExecutionResult,
  },
  data() {
    return {
      activeTab: 'summary',
      activeSubTab: 'TRIGGER',
      filters: null,
      popupVisible: false,
    };
  },
  computed: {
    autoMoveMenuInfo() {
      return this.$store.getters.autoMoveMenuInfo;
    },
  },
  watch: {
    autoMoveMenuInfo: {
      immediate: true,
      handler(val) {
        if (!isEmpty(val) && val.length >= 3) {
          if (val[1].id === 'result') {
            this.$nextTick(() => {
              this.activeTab = 'result';
              this.activeSubTab = 'TRIGGER';
            });
            if (val.length === 3) {
              this.$store.dispatch('setAutoMoveMenuInfo', null);
            }
          }
        }
      },
    },
  },
  methods: {
    open() {
      this.activeTab = 'summary';
      this.$store.dispatch('setInitialDatetimeRange', { type: 'interval', interval: 'hour', value: 12 });
      this.$refs.slidingPopup.visible = true;
      this.popupVisible = true;
    },
    closePopup() {
      this.$refs.slidingPopup.visible = false;
      this.popupVisible = false;
      this.activeTab = null;
      this.activeSubTab = 'TRIGGER';
      this.filters = null;
    },
    changeActiveTab(tabName, subTabName, filters) {
      this.activeTab = tabName;
      this.activeSubTab = subTabName;
      this.filters = filters;
    },
    changeSubTab(subTabName) {
      this.activeSubTab = subTabName;
    },
    /**
     * 트리거(혹은 템플릿) 수행 태스크 완료 후 버튼 클릭시 동작
     * 자동화 수행 결과의 시간 조건 최신으로 다시 설정하기 위함
     * @author jeee12
     * @return {[type]} [description]
     */
    forceAmsTriggerResultLoad() {
      const datetimeRangeButton = this.$refs.datetimeRangeButton;
      const dateType = datetimeRangeButton.dateType;
      if (dateType === 'quick') {
        const selectedDatetime = datetimeRangeButton.selectedDatetime;
        datetimeRangeButton.onClickDate(selectedDatetime);
      }
    },
  },
};
</script>

<style lang="scss">
.fit-card-tabs {
  height: 100%;
  .el-tabs__content {
    height: calc(100% - 36px);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/work/popup/AmsSlidingPopup.vue